import React from "react";
import DashboardLayout from "../../components/layout/DashboardLayout";
import styles from "../../styles/pages/Help/index.module.sass";
import faqImg from "../../asset/Images/faq.png";
import { useParams } from "react-router";
import FaqList from "../../components/faq/FaqList";
import GetPricePredictions from "../../components/faq/GetPricePredictions";
import HowUseInsights from "../../components/faq/HowUseInsights";
import AssistantSection from "../../components/faq/AssistantSection";
import AlertSystemGuide from "../../components/faq/AlertSystemGuide";
import GeneralQuestions from "../../components/faq/GeneralQuestions";
import BotFAQ from "../../components/faq/BotFAQ";
import IntegrationFAQ from "../../components/faq/IntegrationFAQ";
import { LazyLoadImage } from "react-lazy-load-image-component";
import usePageTitle from "../../hooks/usePageTitle";
import BotConfigurationHelp from "../../components/faq/BotConfigurationHelp";
import ExchangesConnectionHelp from "../../components/faq/ExchangesConnectionHelp";
import InsightStrategyHelp from "../../components/faq/InsightStrategyHelp";
import {
  MdOutlineSmartToy,
  MdOutlinePsychology,
  MdOutlineAccountBalanceWallet,
  MdOutlineNotificationsActive,
  MdOutlineInsights,
  MdOutlineHelpOutline,
  MdOutlineArrowForwardIos,
} from "react-icons/md";

const faqData = [
  {
    title: "AI Assistant",
    questions: ["Frequently Asked Questions"],
    links: ["assistant-section"],
    type: "AI_Assistant",
    icon: <MdOutlinePsychology />,
    accent: "assistant",
    description: "Get help with your AI trading assistant",
  },
  {
    title: "AI Bot",
    questions: ["Create Bot", "Frequently Asked Questions"],
    links: ["bot-config", "bot-faq"],
    type: "Bot_and_Automation",
    icon: <MdOutlineSmartToy />,
    accent: "bot",
    description: "Set up and configure your automated trading bots",
  },
  {
    title: "Portfolio",
    questions: ["Connect to Exchanges", "Frequently Asked Questions"],
    links: ["integration-connection", "integration-faq"],
    type: "Integration",
    icon: <MdOutlineAccountBalanceWallet />,
    accent: "portfolio",
    description: "Connect exchange accounts and manage your portfolio",
  },
  {
    title: "Alert System",
    questions: ["Step By Step Guide"],
    links: ["alert-system-guide"],
    type: "Alert_System",
    icon: <MdOutlineNotificationsActive />,
    accent: "alert",
    description: "Configure price alerts and stay updated with the market",
  },
  {
    title: "Insights",
    questions: ["Strategy Builder"],
    links: ["strategies"],
    type: "Insight",
    icon: <MdOutlineInsights />,
    accent: "insight",
    description: "Build strategies and understand AI price predictions",
  },
  {
    title: "Other Questions",
    questions: ["General Questions"],
    links: ["general-questions"],
    type: "",
    icon: <MdOutlineHelpOutline />,
    accent: "general",
    description: "Find answers to general and common questions",
  },
];

const Index = () => {
  const params = useParams();
  usePageTitle("Help");

  return (
    <DashboardLayout>
      <div className={styles.faqWrapper}>
        {params?.section === "all" && (
          <>
            <div className={styles.heroSection}>
              <div className={styles.heroContent}>
                <div className={styles.heroBadge}>
                  <MdOutlineHelpOutline />
                  <span>Help Center</span>
                </div>
                {/*<h1 className={styles.heroTitle}>*/}
                {/*  How can we help you today?*/}
                {/*</h1>*/}
                <p className={styles.heroSubtitle}>
                  Explore our comprehensive guides, tutorials, and frequently
                  asked questions to get the most out of CryptoCrispy.
                </p>
                <div className={styles.heroTips}>
                  <div className={styles.tipItem}>
                    <span className={styles.tipDot} />
                    <span>Step-by-step setup guides</span>
                  </div>
                  <div className={styles.tipItem}>
                    <span className={styles.tipDot} />
                    <span>Video walkthrough tutorials</span>
                  </div>
                  <div className={styles.tipItem}>
                    <span className={styles.tipDot} />
                    <span>Detailed feature explanations</span>
                  </div>
                </div>
              </div>
              <div className={styles.heroImageWrap}>
                <LazyLoadImage
                  src={faqImg}
                  alt="FAQ"
                  effect="blur"
                  wrapperClassName={styles.heroImg}
                />
              </div>
            </div>

            {/*<div className={styles.heroSubNav}>*/}
            {/*  <div className={styles.subNavItem}>*/}
            {/*    <MdOutlineArrowForwardIos size={14} />*/}
            {/*    <span>Select a category below to get started</span>*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div className={styles.faqsGrid}>
              {faqData.map((item, index) => (
                <div key={index} className={styles.faqCardCol}>
                  <div
                    className={`${styles.faqCard} ${styles[`accent-${item.accent}`]}`}
                  >
                    <div className={styles.cardHeader}>
                      <div className={styles.cardIconWrap}>{item.icon}</div>
                      <p className={styles.cardDescription}>
                        {item.description}
                      </p>
                    </div>
                    <div className={styles.cardBody}>
                      <FaqList data={item} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {params?.section === "how-get-price-predictions" && (
          <GetPricePredictions />
        )}
        {params?.section === "bot-faq" && <BotFAQ />}
        {params?.section === "bot-config" && <BotConfigurationHelp />}
        {params?.section === "integration-faq" && <IntegrationFAQ />}
        {params?.section === "integration-connection" && (
          <ExchangesConnectionHelp />
        )}
        {params?.section === "how-use-insights" && <HowUseInsights />}
        {params?.section === "strategies" && <InsightStrategyHelp />}
        {params?.section === "assistant-section" && <AssistantSection />}

        {params?.section === "alert-system-guide" && <AlertSystemGuide />}

        {params?.section === "general-questions" && <GeneralQuestions />}
      </div>
    </DashboardLayout>
  );
};

export default Index;
